/* レイアウト用論理棚 */
import React from 'react';

interface Props {
  children: React.ReactNode;
}

const LayoutDivision: React.FC<Props> = ({ children }) => {
  return <div className="layout-division">{children}</div>;
};

export default LayoutDivision;
